// Store holder used to break the require cycle between store.js and the axios
// service layer. The axios interceptors, response handlers and action-command
// validations need getState()/dispatch() at runtime; importing store.js directly
// from there created store -> rootReducer -> apiBaseQuery -> axios -> store.
// store.js calls setStore() right after configureStore(); consumers read getStore()
// lazily inside their runtime callbacks (never at module init).
var storeInstance = null;
export var setStore = function setStore(store) {
  storeInstance = store;
};
export var getStore = function getStore() {
  if (!storeInstance) {
    throw new Error('Store accessed before initialization (setStore was not called yet).');
  }
  return storeInstance;
};